import { useMutation, useQueryClient } from "@tanstack/react-query";
import { signOut as fbSignOut } from "firebase/auth";
import { useRouter } from "next/navigation";

import { auth } from "@/lib/firebase/firebase-client";

import { CROSS_TENANT_QUERY_KEY_ROOTS } from "@/dashboard/constants/cross-tenant-query-keys";
import { DASHBOARD_ROUTES } from "@/dashboard/constants/routes";
import { fetchJson } from "@/dashboard/hooks/api/fetch-json";

export function useSignOut(onBefore?: () => void) {
  const router = useRouter();
  const qc = useQueryClient();

  return useMutation<void, Error, void>({
    mutationFn: async () => {
      onBefore?.();

      // Tell the server to delete the session & tenant cookies
      await fetchJson("/api/dashboard/session", { method: "DELETE" });

      // Sign-out client SDK (clears refresh token etc.)
      await fbSignOut(auth);

      // Cross-tenant keys survive tenant switches — evict on identity change.
      qc.setQueryData(["me"], null);
      qc.removeQueries({ queryKey: ["call-source-status"] });
      for (const key of CROSS_TENANT_QUERY_KEY_ROOTS) {
        qc.removeQueries({ queryKey: [key] });
      }
    },
    onSuccess: () => router.replace(DASHBOARD_ROUTES.SIGN_IN),
  });
}
